import React from 'react';
import AutoCompleteFilter from 'components/list/Filters/types/AutoCompleteFilter';

const PointOfInterestIdFilter = <AutoCompleteFilter
    label='filters.components.pointOfInterestId.label'
    options={ {
        fullWidth: true,
    } }
    searchParams={ {
        size: '12',
    } }
    reference='points-of-interest'
    optionValue='id'
    searchBy='name'
    source='point_of_interest_id'
/>;

export default PointOfInterestIdFilter;



// WEBPACK FOOTER //
// ./src/components/form/filters/PointOfInterestIdFilter.js